<script lang="ts" setup>
import { ChevronDown } from 'lucide-vue-next';
const userStore = useUserStore();
</script>

<template>
  <div class="avatar-container">
    <NuxtImg
      v-if="userStore?.user?.avatar"
      class="avatar-image"
      :src="userStore?.user?.avatar"
      alt=""
      width="40"
      height="40"
    />
    <v-button
      v-else
      class="avatar-button"
      outline
    >
      {{ userStore.user?.name?.slice(0, 1) || 'U' }}
    </v-button>
    <ChevronDown
      v-if="$device.isDesktop"
      :size="20"
    />
  </div>
</template>

<style lang="scss" scoped>
.avatar-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  border-radius: 12px;
  transition: 0.3s;
  padding: 4px;

  @include media-breakpoint-up(md) {
    &:hover {
      background: $background-button-secondary-hover;
    }
  }

  .avatar-image {
    object-fit: cover;
    max-width: 32px;
    width: 32px;
    max-height: 32px;
    height: 32px;
    border-radius: 100px;
  }

  .avatar-button {
    padding: 0;
    width: 32px;
    height: 32px;
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
    border-radius: 100px;
    border: 1px solid $background-button-secondary-hover;
    background: $background-theme-fade;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $foreground-theme;
    background: white;

    &.avatar-button-mobile {
      display: none;

      @include media-breakpoint-down(md) {
        display: flex;
      }
    }
  }
}
</style>
